<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="height: 10px"></div>
      </template>
      <el-table
        :data="tableData"
        :height="maxTableHeight + 42"
        ref="table"
        v-loading="loading"
        border
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column
          label="平台名称"
          prop="platformName"
          width="120px"
        ></el-table-column>
        <el-table-column label="店铺名称" prop="shopName"></el-table-column>
        <el-table-column
          label="店铺简称"
          prop="shopAbbreviation"
          width="160px"
        ></el-table-column>
        <el-table-column label="是否需要提报" prop="report" width="160px">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.flag"
              v-model="scope.row.report"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in reportOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <span v-else>{{ scope.row.report }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否统计对比" prop="isStatistics" width="160px">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.flag"
              v-model="scope.row.isStatistics"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in reportOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <span v-else>{{ scope.row.isStatistics }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="更新人"
          prop="updatedBy"
          width="120px"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="updatedDate"
        ></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="updateAdd(scope.row)">
              {{ !scope.row.flag ? "编辑" : "保存" }}
            </el-link>
            <el-link
              type="warning"
              :underline="false"
              @click="cancel"
              v-if="scope.row.flag"
              style="margin-left: 10px"
            >
              取消
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';

export default {
  mixins: [tableMixin],
  data() {
    return {
      tableData: [],
      loading: false,
      reportOptions: ["是", "否"]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 编辑/保存
    updateAdd(row) {
      row.flag = !row.flag;
      if (!row.flag) {
        //保存
        this.handleSelectChange(row);
      }
    },
    // 取消
    cancel() {
      this.init();
    },
    async init() {
      this.loading = true;
      let res = await this.$q.preSalePlan.planReportShop();
      if (res.success && res.data) {
        res.data.records.forEach(v => {
          v.flag = false;
          if (!v.isStatistics) {
            v.isStatistics = '否';
          }
        });
        this.tableData = res.data.records;
      } else {
        this.tableData = [];
      }
      this.loading = false;
    },
    async handleSelectChange(row) {
      let data = {
        report: row.report,
        isStatistics: row.isStatistics,
        shopId: row.shopId,
        shopAbbreviation: row.shopAbbreviation
      };
      this.$q.preSalePlan
        .planUpdateReportShop({ data })
        .then(res => {
          if (res.success) {
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
        })
        .finally(_ => {
          this.init();
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .el-input--mini .el-input__inner
  width 64px
</style>
